module.exports = __webpack_public_path__ + "static/data-hero-9d656af347b956d10c3d9454b08aad42.png";